import { t } from 'i18next';
import toast from 'react-hot-toast';

import useIsLoggedIn from '~/hooks/useIsLoggedIn';
import { usePush } from '~/hooks/usePush';

import { getAppGlobals } from '~/components/AppGlobals/utils';

export function useEnablePushNotification() {
  const appGlobals = getAppGlobals();
  const isLoggedIn = useIsLoggedIn();
  const { subscribeToPush, unsubscribeFromPush, isSubscribed, canSendPush } = usePush();

  async function onEnable() {
    if (!isLoggedIn) {
      toast.error(t('nav.push.enable.error'));
      return;
    }
    if (isSubscribed) {
      await unsubscribeFromPush((subscription) => {
        fetch('/push/unsubscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(subscription),
        });
      });
      toast.success(t('nav.push.disable.success'));
    } else {
      if (!canSendPush) {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          return;
        }
      }

      await subscribeToPush(appGlobals.VAPID_PUBLIC_KEY, (subscription) => {
        fetch('/push/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(subscription),
        });
      });
      toast.success(t('nav.push.enable.success'));
    }
  }
  return { onEnable, isSubscribed };
}
